<template>
  <div>
    <h1 class="textcenter">商品详情</h1>
    <el-form ref="form" label-width="160px" class="detail">
      <el-form-item label="公司中文名" >
        <div>{{ form.chineseName }}</div>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
export default {
  data () {
    return {
      form: {
      },
      sts: 0
    }
  },
  mounted () {
    let obj = this.$router.app._route.query.name
    console.log(obj)
  }
}
</script>
<style lang="stylus" scoped>
.textcenter
  text-align center
  margin-bottom 30px
</style>
